import { Button } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React, { useMemo, useRef, useState } from 'react'
import ReactMarkdown from 'react-markdown';
import rehypeKatex from 'rehype-katex';
import remarkMath from 'remark-math';

/** Reconstruct raw markdown (incl. $…$) if callers still pass legacy split segments. */
function messageToMarkdownString(message) {
    if (typeof message === 'string') return message;
    if (!Array.isArray(message)) return String(message ?? '');
    return message.map((m) =>
        m.type === 'text' ? m.content
            : m.type === 'latex-block' ? `$$${m.content}$$`
                : `$${m.content}$`
    ).join('');
}

function DefaultMessageRender({ message }) {
    const text = messageToMarkdownString(message);
    return (
        <ReactMarkdown
            remarkPlugins={[remarkMath]}
            rehypePlugins={[[rehypeKatex, { throwOnError: false, strict: false }]]}
        >
            {text}
        </ReactMarkdown>
    );
}

export {DefaultMessageRender};

export default function MessageBox({ sendMessage, defaultChat = [], renderMessage = null, renderInput = null }) {
    const [chats, setChats] = useState(defaultChat);
    const [message, setMessage] = useState("");
    const [sendingMessage, setSendMessage] = useState(false);
    const containerRef = useRef(null);

    const messagesBlock = useMemo(() => {
        return chats.map((item, index) => <div key={index} className={`comment-div comment-div-${item.me ? "me" : "you"}`}>
            {renderMessage ? renderMessage(item) : <DefaultMessageRender message={item.message} />}
        </div>)
    }, [chats, renderMessage])

    return <div>
        <div ref={containerRef} className='comments-div' style={{
            backgroundColor: "rgb(253, 254, 255)"
        }}>
            {messagesBlock}
        </div>
        <div style={{ position: "relative" }}>
            {renderInput ? renderInput(message, setMessage)
                : <TextArea style={{
                    backgroundColor: "rgb(247, 251, 253)"
                }} value={message} onChange={e => setMessage(e.target.value)} disabled={sendingMessage} />}
            <Button type="primary" style={{ position: "absolute", top: 0, right: 0 }}
                disabled={sendingMessage || !message || (typeof message === "string" && !message.trim())}
                loading={sendingMessage}
                onClick={async () => {
                    setSendMessage(true);
                    const result = await sendMessage(message, setMessage, chats, setChats);
                    if (result) {
                        setChats([...chats, {
                            me: true,
                            message,
                        }, {
                            me: false,
                            message: result,
                        }])
                        setMessage("");
                    }
                    setTimeout(() => {
                        if (containerRef.current) {
                            containerRef.current.lastElementChild?.scrollIntoView({ behavior: "smooth" });
                        }
                    }, 200)
                    setSendMessage(false);
                }}>
                Gửi
            </Button>
        </div>
    </div>
}
